import React from "react";

function Menu(props) {
  return (
    <svg
      {...props}
      width="26"
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height="26"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="9a369a0892">
          <path
            d="M 9.5 105.398438 L 365.75 105.398438 L 365.75 269.648438 L 9.5 269.648438 Z M 9.5 105.398438 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#9a369a0892)">
        <path
          fill="#ffffff"
          d="M 365.640625 132.773438 L 9.609375 132.773438 L 9.609375 105.398438 L 365.640625 105.398438 Z M 365.640625 173.835938 L 9.609375 173.835938 L 9.609375 201.210938 L 365.640625 201.210938 Z M 365.640625 242.273438 L 9.609375 242.273438 L 9.609375 269.648438 L 365.640625 269.648438 Z M 365.640625 242.273438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default Menu;
